/* eslint-disable @typescript-eslint/naming-convention */
export enum IntervalTableEnum {
	HoleIntervalMajor = 'HOLE_INTERVAL_MAJOR',
	HoleIntervalMinor = 'HOLE_INTERVAL_MINOR'
}
